module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h4', [_c('i', {
    staticClass: "fa fa-fw fa-terminal"
  }), _vm._v(" " + _vm._s(_vm.$route.params.command))]), _c('hr'), _c('h4', {
    staticClass: "section"
  }, [_vm._v("Command syntax")]), _c('p'), _c('div', {
    staticClass: "command-params"
  }, _vm._l((_vm.apiData.usage), function(usage) {
    return _c('p', {
      staticClass: "usage"
    }, [_vm._v(_vm._s(usage))])
  })), _c('p'), _c('h4', {
    staticClass: "section"
  }, [_vm._v("Description")]), _c('p', {
    staticClass: "regular-text",
    domProps: {
      "innerHTML": _vm._s(_vm.apiData.description)
    }
  }), (_vm.apiData.params) ? _c('div', [_c('h4', {
    staticClass: "section"
  }, [_vm._v("Parameters")]), _c('ul', _vm._l((_vm.apiData.params), function(param, paramName) {
    return _c('li', [_c('code', [_vm._v(_vm._s(_vm.formatParam(param, paramName)))]), _vm._v("{ " + _vm._s(param.type) + " } -  "), _c('span', {
      domProps: {
        "innerHTML": _vm._s(param.description)
      }
    }), (param.fields) ? _c('ul', _vm._l((param.fields), function(field, fieldName) {
      return _c('li', [_c('code', [_vm._v(_vm._s(_vm.formatParam(field, fieldName)))]), _vm._v("{ " + _vm._s(field.type) + " } -  "), _c('span', {
        domProps: {
          "innerHTML": _vm._s(field.description)
        }
      })])
    })) : _vm._e()])
  }))]) : _vm._e(), _c('hr'), (_vm.apiData.example) ? _c('p', {
    staticClass: "regular-text content-section"
  }, [_c('strong', [_vm._v("Example:")]), _vm._v(" " + _vm._s(_vm.apiData.example.description))]) : _vm._e(), _c('p', [_c('pre', {
    directives: [{
      name: "syntax-highlight",
      rawName: "v-syntax-highlight",
      value: (_vm.apiData.example.code),
      expression: "apiData.example.code"
    }]
  })]), _c('p'), _vm._l((_vm.apiData.content), function(content) {
    return _c('div', [(content.type === 'example') ? _c('div', [_c('p', {
      staticClass: "regular-text content-section"
    }, [_c('strong', [_vm._v("Example:")]), _vm._v(" " + _vm._s(content.description))]), _c('p', [_c('pre', {
      directives: [{
        name: "syntax-highlight",
        rawName: "v-syntax-highlight",
        value: (content.code),
        expression: "content.code"
      }]
    })]), _c('p')]) : _vm._e(), (content.type === 'html') ? _c('div', {
      staticClass: "content-section regular-text",
      domProps: {
        "innerHTML": _vm._s(content.html)
      }
    }) : _vm._e(), (content.type === 'code') ? _c('div', {
      staticClass: "content-section"
    }, [_c('pre', {
      directives: [{
        name: "syntax-highlight",
        rawName: "v-syntax-highlight",
        value: (content.code),
        expression: "content.code"
      }]
    })]) : _vm._e()])
  })], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-dfb0e224"}!./~/vue-loader/lib/template-compiler/preprocessor.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/FullApiDoc.vue
// module id = 172
// module chunks = 1